// extracted by css-extract-rspack-plugin
export default {"linkItem":"LinkedIssues-module__linkItem__ASjGs","rowText":"LinkedIssues-module__rowText__m4N8_","issueNumber":"LinkedIssues-module__issueNumber__zW0uT"};